import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';
import { useNavigationBlocker } from 'router/NavigationBlockerProvider';

const Item = ({ id, onChangePath, active = false, path, text }) => {
  const { navigateSafely } = useNavigationBlocker();
  const { t } = useTranslation();

  const handleClick = (e) => {
    const blocked = navigateSafely(`/${path}`);
    if (blocked) {
      e.preventDefault();
      return;
    }
    onChangePath(id);
  };

  return (
    <Link onClick={handleClick} to={`/${path}`}>
      <div className={`item${active ? ' active' : ''}`}>
        <span>{t(text)}</span>
      </div>
    </Link>
  );
};
Item.propTypes = {
  id: PropTypes.number.isRequired,
  onChangePath: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

export default Item;
